import { MaskText, SectionLabel, Reveal } from "./primitives";

const CHAPTERS = [
  {
    n: "01",
    title: "Listen",
    body: "Every engagement starts with immersion — audits, interviews and market truth. We learn your business before we touch a pixel.",
  },
  {
    n: "02",
    title: "Strategy",
    body: "We define the positioning, the audience and the single idea worth betting on. Direction before decoration, always.",
  },
  {
    n: "03",
    title: "Create",
    body: "Identity, content, film and product — designed and produced in-house with obsessive attention to craft.",
  },
  {
    n: "04",
    title: "Amplify",
    body: "We launch, measure and optimise across channels so the work keeps compounding long after go-live.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-dm-cream py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <SectionLabel tone="teal" className="text-dm-teal">How we work</SectionLabel>
            <MaskText
              lines={["A process", "built for", "impact."]}
              className="mt-5 font-display font-extrabold text-dm-dark tracking-tighter leading-[0.92] text-5xl md:text-6xl"
            />
            <p className="mt-6 max-w-xs text-dm-dark/60 leading-relaxed">
              Four chapters, one obsession — turning ambition into measurable
              momentum for the brands we partner with.
            </p>
          </div>
        </div>

        <div className="lg:col-span-8 lg:col-start-5">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.05}>
              <div
                data-testid={`process-chapter-${i}`}
                className="group relative border-t py-10 md:py-14 grid grid-cols-12 gap-4"
                style={{ borderColor: "rgba(10,10,10,0.14)" }}
              >
                <span
                  className="col-span-12 md:col-span-3 font-display font-extrabold text-6xl md:text-7xl leading-none tracking-tighter"
                  style={{ color: i % 2 === 0 ? "var(--dm-teal)" : "var(--dm-maroon)" }}
                >
                  {c.n}
                </span>
                <div className="col-span-12 md:col-span-9">
                  <h3 className="font-display font-bold text-3xl md:text-4xl tracking-tight text-dm-dark">
                    {c.title}
                  </h3>
                  <p className="mt-3 max-w-xl text-dm-dark/60 leading-relaxed text-base md:text-lg">
                    {c.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
